import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getTransportationGroupsListAPI = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/transportation-groups`,
    method: 'get',
  });
};

export type TransportationGroupsListResponse = {
  codeDesc: string;
  codeId: string;
}[];

export const fetchTransportationGroupsList = async (): Promise<TransportationGroupsListResponse> => {
  const response: AxiosResponse<TransportationGroupsListResponse> = await getTransportationGroupsListAPI();
  return response.data;
};
